const firstPresent = (...values) => values.find((value) => value != null && `${value}`.trim()) || "";

export const resolveReservationProperty = (reservation, rentals = []) => {
  const matchingRental = rentals.find(
    (rental) => `${rental?.pms_id || ""}` === `${reservation?.pms_id || ""}`,
  );

  const name = firstPresent(
    reservation?.rental_name,
    reservation?.property_name,
    reservation?.rental?.name,
    matchingRental?.name,
  );
  const address = firstPresent(
    reservation?.rental_address,
    reservation?.property_address,
    reservation?.rental?.address,
    matchingRental?.address,
  );
  const propertyId = firstPresent(
    reservation?.pms_id,
    reservation?.rental_code,
    matchingRental?.pms_id,
  );

  return {
    name,
    address,
    propertyId,
    primary: name || address || propertyId || "Property",
    secondary: name && address ? address : "",
  };
};

export const reservationMatchesPropertySearch = (reservation, rentals, searchTerm) => {
  const normalizedSearch = `${searchTerm || ""}`.trim().toLocaleLowerCase();
  if (!normalizedSearch) return true;

  const property = resolveReservationProperty(reservation, rentals);
  return [property.name, property.address, property.propertyId]
    .filter(Boolean)
    .some((value) => `${value}`.toLocaleLowerCase().includes(normalizedSearch));
};
